import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Layout = ({ children, hideHeader = false, hideFooter = false }) => {
  return (
    <>
      {!hideHeader && <Header />}
      {children}
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;
